<script setup lang="ts">
interface Props {
  search?: boolean
}
const { search } = defineProps<Props>()
const store = useStore()
const { modal } = storeToRefs(store)
const load = () => {
  store.getModal(true, 'Filtry')
}
</script>

<template>
  <div>
    <Modal v-if="modal">
      <FiltersMobileFilters :search="search" />
    </Modal>
    <div class="flex gap-[5px]">
      <div class="bg-secondary-hover text-14 text-white rounded-[5px] px-[10px] py-[5px]" @click="load()">
        Filtry
      </div>
    </div>
  </div>
</template>
